<template>
  <el-container>
    <Loader/>

    <!-- Aside -->
    <el-aside width="250px">
      <div class="aside__wrapper" :class="asideClass">
        <Logo/>

        <slot name="sidenav"></slot>
      </div>
    </el-aside>

    <!-- Main -->
    <slot name="main"></slot>

  </el-container>
</template>

<script>
import Loader from '@/components/Loader'
import Logo from '@/components/Logo'

export default {
  props: {
    asideType: {
      type: String,
      required: true
    }
  },
  components: {
    Loader,
    Logo
  },
  computed: {
    asideClass () {
      return (this.asideType === 'admin') ? 'aside__admin' : 'aside__home'
    }
  }
}
</script>
